// extracted by mini-css-extract-plugin
export default {"wizardButton":"wizardButton_wizardButton__aIdCl"};